export default {
  SET_CHARITIES (state, charities) {
    state.charities = charities
  },
  SET_ACTIVE_CHARITY_INFO (state, charityInfo) {
    state.activeCharityInfo = charityInfo
  },
}
